module.exports = __webpack_public_path__ + "img/withdrawIcon.1ba2af0c.svg";